import {
  ArgosFeatures,
  HabitatFeatures,
  TuFeatures,
  WhiteGoodsOnArgosFeatures,
  AfsProductCareOnArgosFeatures,
  TuClothingOnArgosFeatures
} from './index'

const featureBrandConfigs = {
  argos: ArgosFeatures,
  habitat: HabitatFeatures,
  tu: TuFeatures,
  tuclothingonargos: TuClothingOnArgosFeatures,
  whitegoodsonargos: WhiteGoodsOnArgosFeatures,
  afsproductcareonargos: AfsProductCareOnArgosFeatures
}

export default featureBrandConfigs
